import React, { useState, useRef, useCallback } from 'react';
import { Link } from '@material-ui/core';
import { useSelector } from 'react-redux';
import localStorage, { MODULES } from '../../../../../utils/localStorage';
import styles from './RequestConsulting.module.less';
import nowSvg from '../../../../../assets/images/now.svg';
import helpSvg from '../../../../../assets/images/help.svg';
import questionSvg from '../../../../../assets/images/question.svg';
import cloudAssistantSvg from '../../../../../assets/images/cloud-assistant.svg';
import chevronRightSvg from '../../../../../assets/images/chevron-right.svg';
import chevronLeftSvg from '../../../../../assets/images/chevron-left.svg';

const getInitialExpanded = () => {
  const userData = localStorage.getModule(MODULES.USER);
  return userData?.supportPanelExpanded ?? true;
};

const RequestConsulting = () => {
  const [expanded, setExpanded] = useState(getInitialExpanded);
  const [animating, setAnimating] = useState(false);
  const panelRef = useRef(null);
  const navs = useSelector(state => state.footer?.navs);
  const helperCenterLink =
    navs?.find(nav => nav.text === 'Help Center')?.url || '';

  const serviceNowLink =
    'https://servicenow.i.mercedes-benz.com/esc?id=sc_cat_item&sys_id=ba2e1df91b51c110eba9c9936b4bcb1a&sysparm_variables=eyJhcHBsaWNhdGlvbl9zZXJ2aWNlX3Byb3ZpZGVyIjoiYWE0MTNhNGVkYmE5ODkxMDkzYTU2NWZiZDM5NjE5MjIiLCJzZXJ2aWNlX29mZmVyaW5nX293biI6IjBmNzI3YWNlZGJhOTg5MTA5M2E1NjVmYmQzOTYxOWNiIiwiY29uc3VsdGluZ190eXBlIjoiNTYzY2RjMzYxYmQ4ZWRkYzg2YmZkZGI2YmI0YmNiZTMifQ%3D%3D';

  const serviceNowHelpLink = 'https://pages.cn.svc.corpintra.net/faq/en/';

  const cloudAssistantLink =
    'https://ai.ittz-tech-platform.cn.svc.corpintra.net/';

  const handleTransitionEnd = useCallback(() => {
    setAnimating(false);
  }, []);

  const toggle = useCallback(
    value => {
      if (animating) return;
      setAnimating(true);
      setExpanded(value);
      localStorage.setModule(MODULES.USER, {
        supportPanelExpanded: value
      });
    },
    [animating]
  );

  return (
    <div className={styles.wrapper}>
      {/* Collapsed tab */}
      <div
        className={`${styles.collapsedButton} ${
          expanded ? styles.collapsedHidden : ''
        }`}
        onClick={() => toggle(true)}>
        <img src={helpSvg} alt='support' className={styles.collapsedIcon} />
        <span>Support</span>
        <img
          src={chevronLeftSvg}
          alt='expand'
          className={styles.collapsedArrow}
        />
      </div>

      {/* Expanded panel */}
      <div
        ref={panelRef}
        className={`${styles.panel} ${expanded ? styles.panelVisible : ''}`}
        onTransitionEnd={handleTransitionEnd}>
        <div
          className={styles.header}
          onClick={() => toggle(false)}
          role='button'
          tabIndex={0}
          onKeyDown={e => e.key === 'Enter' && toggle(false)}>
          <img src={helpSvg} alt='support' />
          <span className={styles.headerTitle}>Support</span>
          <img
            src={chevronRightSvg}
            alt='collapse'
            className={styles.headerArrow}
          />
        </div>
        <div className={styles.expandContainer}>
          <div className={styles.linkItem}>
            <img src={nowSvg} alt='ServiceNow' />
            <Link
              href={serviceNowLink}
              color='inherit'
              className={styles.consulting}
              target='_blank'
              underline='none'>
              Request Consulting
            </Link>
            <Link
              href={serviceNowHelpLink}
              className={styles.help}
              target='_blank'
              underline='none'>
              Help
            </Link>
          </div>
          <div className={styles.linkItem}>
            <img src={cloudAssistantSvg} alt='Cloud Assistant' />
            <Link
              href={cloudAssistantLink}
              color='inherit'
              className={styles.consulting}
              target='_blank'
              underline='none'>
              Cloud Assistant
            </Link>
          </div>
          <div className={styles.linkItem}>
            <img src={questionSvg} alt='help center' />
            <Link
              href={helperCenterLink}
              color='inherit'
              className={styles.consulting}
              target='_blank'
              underline='none'>
              Help Center
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequestConsulting;
